<template>
  <footer>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
      <div class="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left space-x-4">
        <span>
          <router-link :to="{name: 'project'}">
            Über St. Audio
          </router-link>
        </span>
        <span>
          <router-link :to="{name: 'changelog'}">
            Neu im Studio
          </router-link>
        </span>
        <span>
          <a href="/help" target="_blank">
            Feedback &amp; Support
          </a>
        </span>
        <span>
          <a href="/club" target="_blank">
            &#9829; Growth Club
          </a>
        </span>
        <span>
          <a href="/newsletter" target="_blank">
            Newsletter
          </a>
        </span>
        <span>
          <a href="/privacy" target="_blank">
            Datenschutz
          </a>
        </span>
        <span>
          <a href="/terms" target="_blank">
            AGB
          </a>
        </span>
        <span>
          <a href="/imprint" target="_blank">
            Impressum
          </a>
        </span>
      </div>
    </div>
  </footer>
</template>
